import { Button, UIHeading2, UIText1, useDeviceType } from '@cian/ui-kit';
import { FC, useEffect } from 'react';
import { clsx } from 'clsx';
import successSvgUrl from './success.svg';
import * as styles from './DobroFormSuccess.css';

interface IDobroFormSuccessProps {
  buttonOnClick: () => void;
}

export const DobroFormSuccess: FC<IDobroFormSuccessProps> = props => {
  const { buttonOnClick } = props;
  const deviceType = useDeviceType();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const img = (
    <div className={styles.image}>
      <img src={successSvgUrl} />
    </div>
  );

  return (
    <div
      className={clsx(styles.page, {
        [styles.desktop]: deviceType === 'desktop',
      })}
    >
      {deviceType !== 'desktop' && img}
      <div className={styles.heading}>
        <UIHeading2>Заявка отправлена</UIHeading2>
      </div>
      <div className={styles.text}>
        <UIText1>Сотрудники фонда перезвонят вам, когда&nbsp;найдут&nbsp;подходящих подопечных</UIText1>
      </div>

      {deviceType === 'desktop' && img}
      <div className={styles.button}>
        <Button fullWidth={deviceType !== 'desktop'} onClick={buttonOnClick}>
          Буду ждать
        </Button>
      </div>
    </div>
  );
};
